export function intro(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Sempai']
        },
        {
          type: 'ol',
          definition: 'noun.',
          content: ['People who were born before you.', 'The college students & young professionals who create and facilitate each camp.']
        }
      ],
      [
        {
          type: 'p',
          content: ['Our camp creators—known as sempai—work together in an intense creative and collaborative environment to share their own pursuits with our camp participants—known as kohai. They imagine, in action and from the ground up, what a meaningful learning environment looks like.']
        },
        {
          type: 'p',
          content: ['The kohai who come to Gakko camps are high school students seeking ‘something more’ from their education. Your responsibility as a sempai is to bring your passion, unique perspective and skills to the table to meet the kohai where they need to be met. Over the course of the summer, you will be responsible for collectively orchestrating a two-week educational experience, planning your workshops and mentoring high school students from all corners of the globe. All sempai expenses, including travel, accommodations and living expenses will be covered by Gakko.']
        }
      ],
      [
        {
          type: 'p',
          content: ['Being a sempai is a unique opportunity to grow in your interests alongside exceptional collaborators in an interdisciplinary environment while responding to the needs of a diverse group of kohai, as well as the local culture of a given location. We invite you to the journey to question learning, and to reimagine the potential of education.']
        },
        {
          type: 'h5',
          content: 'Sempai applications for 2018 will open in December 2017.'
          //outbound: true,
          //linkURL: 'https://jobs.lever.co/gakkoproject/38df5eed-8659-441a-b040-9ac172f9c0eb/apply'
        }
      ]
    ]
  }
}


export function locationIntro(data) {
  // Feeds into RowThreeText
  return {
    content: [
      [
        {
          type: 'h3',
          content: ['Four Locations', 'Two Travelling Troupes']
        }
      ],
      [
        {
          type: 'p',
          content: ['This year, we are seeking sempai to design a camp and take it on a tour: two teams of sempai will be traveling to four locations, each team holding two camps in two different countries, with two different groups of kohai.']
        },
        {
          type: 'p',
          content: ['The whole sempai cohort will first gather in a château in Burgundy, France, and spend two weeks getting to know one another as collaborators. There, sempai will begin building the camps. Each sempai will be putting together a workshop or series of experiences that communicates the idea, the craft or the pursuit that drives them.']
        }
      ],
      [
        {
          type: 'p',
          content: ['Together, the two teams of sempai will also be thinking about the ‘connective tissue’ of their camp by asking themselves: how do we articulate the narrative arc of this experience?']
        },
        {
          type: 'p',
          content: ['Having picked each other’s brains and hearts, the two troupes will then go their separate ways to their respective locations to host the camps.']
        }
      ]
    ]
  }
}


export function faq(data) {
  return {
    title: data['faq-title'],
    subTitle: data['faq-subtitle'],
    english: data['faq-sempai-eng'],
    japanese: data['faq-sempai-jap'],
    definition: data['faq-def-a-1'],
    wordType: data['faq-def-a-2'],
    definition2: data['faq-def-b'],
    definition3: data['faq-def-c'],
    button: data['faq-button'],
    linkURL: 'https://jobs.lever.co/gakkoproject/38df5eed-8659-441a-b040-9ac172f9c0eb/apply',
    deadline: 'Deadline: Jan 10th 2017',
    questions: [
      {
        question: data['question-a'],
        answer: data['answer-a']
      },
      {
        question: data['question-b'],
        answer: data['answer-b']
      },
      {
        question: data['question-c'],
        answer: data['answer-c']
      },
      {
        question: data['question-d'],
        answer: data['answer-d']
      },
      // {
      //   question: data['question-e'],
      //   answer: data['answer-e']
      // },
      // {
      //   question: data['question-f'],
      //   answer: data['answer-f']
      // },
      // {
      //   question: data['question-g'],
      //   answer: data['answer-g']
      // },
      {
        question: data['question-h'],
        answer: data['answer-h']
      },
      {
        question: data['question-i'],
        answer: data['answer-i']
      },
      {
        question: data['question-j'],
        answer: data['answer-j']
      }
    ]
  }
}

export function timeline(data) {
  return {
    title: {
      content: [
        [
          {
            type: 'h3',
            content: [data['timeline']]
          }
        ]
      ]
    },
    content: [
      [
        {
          year: 2016,
          date: data['timeline-a'],
          title: data['timeline-a-title'],
          subTitle: data['timeline-a-sub']
        },
        {
          date: data['timeline-b'],
          title: data['timeline-b-title'],
          subTitle: data['timeline-b-sub']
        }
      ],
      [
        {
          year: 2017,
          date: data['timeline-c'],
          title: data['timeline-c-title'],
          subTitle: data['timeline-c-sub']
        },
        {
          date: data['timeline-d'],
          title: data['timeline-d-title'],
          subTitle: data['timeline-d-sub']
        }
      ],
      [
        {
          date: data['timeline-e'],
          title: data['timeline-e-title'],
          subTitle: data['timeline-e-sub']
        },
        {
          date: data['timeline-f'],
          title: data['timeline-f-title'],
          subTitle: data['timeline-f-sub']
        }
      ]
    ],
    contentLarge: [
      {
        date: data['timeline-g'],
        content: [
          {
            title: {
              content: data['timeline-g-title']
            },
            subTitle: {
              content: data['timeline-g-sub']
            }
          }
        ]
      },
      {
        date: data['timeline-h'],
        content: [
          {
            title: {
              content: data['timeline-h-title-a']
            },
            subTitle: {
              content: data['timeline-h-sub-a']
            }
          },
          {
            title: {
              content: data['timeline-h-title-b']
            },
            subTitle: {
              content: data['timeline-h-sub-b']
            }
          },
          {
            title: {
              content: data['timeline-h-title-c']
            },
            subTitle: {
              content: data['timeline-h-sub-c']
            }
          }
        ]
      },
      {
        date: data['timeline-i'],
        content: [
          {
            title: {
              content: data['timeline-i-title-a']
            },
            subTitle: {
              content: data['timeline-i-sub-a']
            }
          },
          {
            title: {
              content: data['timeline-i-title-b']
            },
            subTitle: {
              content: data['timeline-i-sub-b']
            }
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/modules/sempai.js